<template>
  <v-dialog v-model="internalDialog" max-width="1200" transition="dialog-bottom-transition">
    <v-card class="bg-transparent elevation-0">
      <div class="position-relative">
        <v-btn
          icon
          class="position-absolute"
          style="top: 10px; right: 10px; z-index: 20; background-color: rgba(0,0,0,0.5); color: white;"
          @click="closeDialog"
          size="small"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-carousel
          v-model="currentIndex"
          :show-arrows="images.length > 1 ? 'hover' : false"
          hide-delimiters
          height="80vh"
          theme="dark"
          style="border-radius: 12px; overflow: hidden;"
        >
          <v-carousel-item
            v-for="(img, i) in images"
            :key="i"
          >
            <div class="d-flex w-100 h-100 align-center justify-center">
              <v-img :src="img.src" max-height="80vh" max-width="100%" />
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  images: {
    type: Array,
    default: () => []
  },
  initialIndex: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['update:modelValue']);

const internalDialog = ref(props.modelValue);
const currentIndex = ref(props.initialIndex);

watch(() => props.modelValue, (newVal) => {
  internalDialog.value = newVal;
  if (newVal) {
    currentIndex.value = props.initialIndex;
    window.addEventListener('keydown', handleKeyDown);
  } else {
    window.removeEventListener('keydown', handleKeyDown);
  }
});

const handleKeyDown = (e) => {
  if (e.key === 'ArrowRight') {
    nextImage();
  } else if (e.key === 'ArrowLeft') {
    prevImage();
  } else if (e.key === 'Escape') {
    closeDialog();
  }
};

const nextImage = () => {
  if (currentIndex.value < props.images.length - 1) {
    currentIndex.value++;
  } else {
    currentIndex.value = 0; // loop back to start
  }
};

const prevImage = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
  } else {
    currentIndex.value = props.images.length - 1; // loop to end
  }
};

watch(internalDialog, (newVal) => {
  if (!newVal) {
    emit('update:modelValue', false);
  }
});

watch(() => props.initialIndex, (newVal) => {
  currentIndex.value = newVal;
});

const closeDialog = () => {
  internalDialog.value = false;
};
</script>

<style scoped>
</style>
